/** Mailing-list block, reproducing the source site's published wording.
 *
 *  It is a STUB: the operator has not yet told us where a submission should go,
 *  so the field and button are inert. Nothing is captured, nothing is posted and
 *  no success is ever claimed -- telling someone they are subscribed when no
 *  record exists is worse than not offering it. The `footnote` differs per page
 *  because the source site publishes two different promises.
 */
export const MailingList = ({ footnote, testId = "mailing-list" }) => (
  <section data-testid={testId} className="border-y border-sand-border bg-sand-card py-16 lg:py-20">
    <div className="mx-auto max-w-2xl px-5 text-center lg:px-10">
      <h2 className="font-display text-3xl font-extrabold text-navy lg:text-4xl">
        Join our mailing list
      </h2>
      <p className="mt-3 text-base font-semibold text-slate-600">Never miss an update</p>

      <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
        {/* TODO: destination pending from operator */}
        <input
          type="email"
          placeholder="Enter your email"
          aria-label="Enter your email"
          disabled
          aria-disabled="true"
          data-testid={`${testId}-email-input`}
          className="w-full cursor-not-allowed rounded-full border border-sand-border bg-white/60 px-6 py-3.5 text-sm text-slate-500 placeholder:text-slate-400"
        />
        <button
          type="button"
          disabled
          aria-disabled="true"
          data-testid={`${testId}-send-button`}
          className="shrink-0 cursor-not-allowed rounded-full border border-navy/15 bg-white px-8 py-3.5 text-sm font-bold text-navy/50"
        >
          Send
        </button>
      </div>

      <p data-testid={`${testId}-footnote`} className="mt-5 text-xs text-slate-500">
        {footnote}
      </p>
    </div>
  </section>
);

export default MailingList;
